import React from 'react';
import { UserSideBar } from '@components';
import { USER_MENU_SIDE_BAR } from '@configs';

export const UserSideBarModule = () => {
  return <UserSideBar dataList={USER_MENU_SIDE_BAR} />;
};
